import './linked_in_content.js.coffee'
Namespace 'Monitoring.Models.SocialContents.LinkedIn'


class Monitoring.Models.SocialContents.LinkedIn.LinkedInPostContent extends
      Monitoring.Models.SocialContents.LinkedIn.LinkedInContent

  constructor: (linkedInAuthor, linkedInPost) ->
    @linkedInPost = linkedInPost
    super(linkedInAuthor)

  getJson: ->
    new Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInPostSerializer().serialize(@)

  getMainText: ->
    @linkedInPost.getText()

  getCreatedAt: ->
    @linkedInPost.getCreatedAt()

  getParentId: ->
    null

  getContentId: ->
    @linkedInPost.getContentId()

  isBrandContent: ->
    @linkedInPost.getIsBrandContent()

  getSubType: ->
    'li-post'

  getPrivacy: ->
    'public'

  hasMedia: ->
    @linkedInPost.getHasMedia()

  postURL: ->
    @linkedInPost.postURL()
